import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

import { AppContext } from '../../context/AppContext';
import { ProgressBar, Layout, DimensionsImage } from '../../components';
import { Button, Headline, TextInput } from '../../elements';

import { PRODUCTS } from '../../navigation/routes';
import { UPDATE_ELEVATOR_DATA } from '../../context/ActionTypes';
import styles from  './DimensionsPage.module.scss';


const DimensionsPage = () => {
	const { state, dispatch } = React.useContext(AppContext);
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({ criteriaMode: 'all', mode: 'onBlur' });
	const navigate = useNavigate();
	const { id } = useParams();
	const elevatorData = state.configuration.elevators ? state.configuration.elevators[state.elevatorIndex] : null;
	const [currentArrow, setCurrentArrow] = React.useState('');

	const onSubmit = (data) => {
		dispatch({
			type: UPDATE_ELEVATOR_DATA,
			payload: data,
		});

		navigate(`${PRODUCTS}/${id ? id : ''}`);
	};

	return (
		<Layout>
			<ProgressBar />
			<Headline variant='h2'>Abmessungen des Aufzugs</Headline>

			<DimensionsImage visibleArrow={currentArrow} />

			<form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
				<TextInput
					type='number'
					label='Breite der Kabine (mm)'
					errors={errors}
					defaultValue={elevatorData ? elevatorData.width_of_cabin : ''}
					onFocus={() => setCurrentArrow('width_of_cabin')}
					{...register('width_of_cabin', {
						required: true,
						min: { value: 1000, message: 'Breite muss mind. 1000 mm betragen' },
						max: { value: 5000, message: 'Breite darf max. 5000 mm betragen' },
					})}
				/>

				<TextInput
					type='number'
					label='Tiefe der Kabine (mm)'
					errors={errors}
					defaultValue={elevatorData ? elevatorData.depth_of_cabin : ''}
					onFocus={() => setCurrentArrow('depth_of_cabin')}
					{...register('depth_of_cabin', {
						required: true,
						min: { value: 1000, message: 'Tiefe muss mind. 1000 mm betragen' },
						max: { value: 5000, message: 'Tiefe darf max. 5000 mm betragen' },
					})}
				/>

				<TextInput
					type='number'
					label='Höhe der Kabine (mm)'
					errors={errors}
					defaultValue={elevatorData ? elevatorData.height_of_cabin : ''}
					onFocus={() => setCurrentArrow('height_of_cabin')}
					{...register('height_of_cabin', {
						required: true,
						min: { value: 2000, message: 'Höhe muss mind. 2000 mm betragen' },
						max: { value: 3000, message: 'Höhe darf max. 3000 mm betragen' },
					})}
				/>
				
				<TextInput
					type='number'
					label='Höhe der Kabinentür (mm)'
					errors={errors}
					defaultValue={elevatorData ? elevatorData.height_of_cabin_door : ''}
					onFocus={() => setCurrentArrow('height_of_cabin_door')}
					{...register('height_of_cabin_door', {
						required: true,
						min: { value: 2000, message: 'Höhe muss mind. 2000 mm betragen' },
						max: { value: 2600, message: 'Höhe darf max. 2600 mm betragen' },
					})}
				/>
				
				<TextInput
					type='number'
					label='Breite der Kabinentür (mm)'
					errors={errors}
					defaultValue={elevatorData ? elevatorData.width_of_cabin_door : ''}
					onFocus={() => setCurrentArrow('width_of_cabin_door')}
					{...register('width_of_cabin_door', {
						required: true,
                        min: { value: 800,  message: 'Höhe muss mind. 800 mm betragen' },
                        max: { value: 4000, message: 'Höhe darf max. 4000 mm betragen' },
					})}
				/>


				<div className={styles.footer}>
					<Button
						type='button'
						title='Zurück'
						variant='outline'
						onClick={() => navigate(-1)}
					/>
					<Button type='submit' title='Weiter' />
				</div>
			</form>
		</Layout>
	);
};

export default DimensionsPage;
